<template>
    <div>
        <app-input id="price"
                   v-model="form.price"
                   type="number"
                   name="price"
                   rules="required"
                   class="w-50 float-left"
                   :placeholder="$t('Regular price')"
                   @input="updatePrice(false)"
                   @blur="updatePrice(true)"
                   small/>
        <app-input id="discount_price"
                   v-model="form.discount_price"
                   type="number"
                   name="discount_price"
                   class="w-50 float-right"
                   :placeholder="$t('Discount price')"
                   @input="updatePrice(false)"
                   @blur="updatePrice(true)"
                   discountPrice
                   small/>
    </div>
</template>

<script>
import PriceService from '@services/price.service';
import debounce from 'lodash/debounce';

export default {
    name: 'AppPrice',
    props: {
        range: Object
    },
    data() {
        return {
            form: {}
        };
    },
    methods: {
        updatePrice(immediately) {
            if(immediately) {
                this.savePriceDebounce.cancel();
                this.store();
                return;
            }
            this.savePriceDebounce();
        },
        store() {
            PriceService.update(this.form.price_id, this.form).then(() => this.$toastr.s(this.$t('Updated'))) ;
        }
    },
    created() {
        this.form = Object.assign({}, this.range);
        this.form.price = this.form.price / 100;
        this.form.discount_price = this.form.discount_price / 100;
        this.savePriceDebounce = debounce((immediately) => {
            this.store(immediately);
        }, 1000);
    }
};
</script>
